import { useMantineColorScheme } from "@mantine/core";
import { UnderConstruction } from "components/UnderConstruction";

const ManageDefaultPage: React.FC = () => {
  const { colorScheme } = useMantineColorScheme();

  return <UnderConstruction />;
};

export default ManageDefaultPage;
